module.exports = __webpack_public_path__ + "media/images/powerpoint/media/fieldwork_dates-fc901e91dca38cf7ff290471f097a7c9.png";